import { BlogImage } from './BlogImage';
import { ImageGrid } from './ImageGrid';
import { ImageRow } from './ImageRow';
import { ImageCompare } from './ImageCompare';
import { Gallery } from './Gallery';
import { Alert } from './Alert';
import { Tabs, Tab } from './Tabs';
import { Accordion, AccordionItem } from './Accordion';
import { CTAButton } from './CTAButton';
import { Columns, Column } from './Columns';
import { ComparisonTable } from './ComparisonTable';
import { Odsazeni } from './Odsazeni';
import { Spacer } from './Spacer';
import { LineChart } from './LineChart';
import { BarChart } from './BarChart';
import { PieChart } from './PieChart';

// Custom components for MDX rendering
export const mdxComponents = {
  // Custom image components
  BlogImage,
  ImageGrid,
  ImageRow,
  ImageCompare,
  Gallery,

  // Utility components
  Alert,
  Tabs,
  Tab,
  Accordion,
  AccordionItem,
  CTAButton,
  Columns,
  Column,
  ComparisonTable,
  Odsazeni,
  Spacer,
  LineChart,
  BarChart,
  PieChart,

  // Override default HTML elements with styled versions
  h1: ({ children }: any) => (
    <h1 className="text-4xl font-bold mt-8 mb-4 scroll-m-20">{children}</h1>
  ),
  h2: ({ children }: any) => (
    <h2 className="text-3xl font-semibold mt-8 mb-4 scroll-m-20">{children}</h2>
  ),
  h3: ({ children }: any) => (
    <h3 className="text-2xl font-semibold mt-6 mb-3 scroll-m-20">{children}</h3>
  ),
  p: ({ children }: any) => (
    <p className="leading-7 mb-4">{children}</p>
  ),
  ul: ({ children }: any) => (
    <ul className="my-6 ml-6 list-disc [&>li]:mt-2">{children}</ul>
  ),
  ol: ({ children }: any) => (
    <ol className="my-6 ml-6 list-decimal [&>li]:mt-2">{children}</ol>
  ),
  li: ({ children }: any) => (
    <li className="leading-7">{children}</li>
  ),
  blockquote: ({ children }: any) => (
    <blockquote className="my-6 border-l-4 border-gray-300 dark:border-gray-600 pl-6 pr-4 py-3 italic text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-800/50 rounded-r-md [&>*:last-child]:mb-0">
      {children}
    </blockquote>
  ),
  code: ({ children, className }: any) => (
    <code className={className || 'relative rounded bg-[#0d1117] px-[0.3rem] py-[0.2rem] font-mono text-sm text-gray-200'}>
      {children}
    </code>
  ),
  pre: ({ children }: any) => (
    <pre className="mb-4 mt-6 overflow-x-auto rounded-lg bg-[#0d1117] p-4 text-sm">
      {children}
    </pre>
  ),
  a: ({ href, children }: any) => (
    <a
      href={href}
      className="font-medium text-purple-600 dark:text-purple-400 underline underline-offset-4 hover:text-purple-700 dark:hover:text-purple-300 transition-colors"
      target={href?.startsWith('http') ? '_blank' : undefined}
      rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
    >
      {children}
    </a>
  ),
  hr: () => <hr className="my-8 border-gray-200 dark:border-gray-700" />,
  table: ({ children }: any) => (
    <div className="my-6 w-full overflow-x-auto">
      <table className="w-full border-collapse bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-sm">
        {children}
      </table>
    </div>
  ),
  th: ({ children }: any) => (
    <th className="border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 px-4 py-3 text-left font-bold text-gray-900 dark:text-gray-100 [&[align=center]]:text-center [&[align=right]]:text-right">
      {children}
    </th>
  ),
  td: ({ children }: any) => (
    <td className="border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 text-left text-gray-900 dark:text-gray-200 [&[align=center]]:text-center [&[align=right]]:text-right">
      {children}
    </td>
  ),
};
